import CoreApi from '@/api/CoreApi';
import type { Group, NewGroup } from '@/models/Group';
import type { GroupChildren } from '@/models/GroupChildren';

export async function loadRootGroups(): Promise<Group[]> {
  try {
    const response = await CoreApi.axiosClient.get('/groups/root');
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load groups: ${error.message}`);
  }
}

export async function loadUserGroups(): Promise<Group[]> {
  try {
    const response = await CoreApi.axiosClient.get('/groups/admin');
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load groups: ${error.message}`);
  }
}

export async function loadGroupChildren(
  groupUuid: string,
): Promise<GroupChildren> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/groups/children/${groupUuid}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load groups: ${error.message}`);
  }
}

export async function createGroupInHierarchy(group: NewGroup): Promise<void> {
  try {
    await CoreApi.axiosClient.post('/groups/hierarchy', group);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(error);
  }
}

export async function patchGroupInHierarchy(group: Group): Promise<void> {
  try {
    await CoreApi.axiosClient.patch('/groups/hierarchy', group);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(error);
  }
}

export async function deleteGroupInHierarchy(groupUuid: string): Promise<void> {
  try {
    await CoreApi.axiosClient.delete(`/groups/hierarchy/${groupUuid}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response && error.response.status === 409) {
      throw new Error('The group cannot be deleted because it is not empty.');
    }
    throw new Error(
      error.message || 'An error occurred while deleting the group.',
    );
  }
}
